
import { useEffect } from 'react'
import Select from 'react-select'
import { WaterSupplyPumpingStationDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { AstricSign } from '../../Helper/AstricSign'
import { useAuthState } from '../../Helper/Context'


export const WaterSupplyPumpingStationDataDDL = (props) => {
    const { WaterSupplyPumpingStation, setWaterSupplyPumpingStation, Flag, rowData, IsDisabled, WardName, DashProjectTypeId = false } = props
    // console.log(rowData)
    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            UserID,
            token,
            M_WardID: WardName.ID,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }
        { WardName.ID != "0" && dispatch(WaterSupplyPumpingStationDDLAPI({ data })) }
    }, [WardName.ID, DashProjectTypeId, RoleID])


    const { WaterSupplyPumpingStationData } = useSelector(state => state.WaterSupplyPumpingStationDDLData)

    useEffect(() => {
        handleCropNameDDL()
    }, [WaterSupplyPumpingStationData])

    const handleCropNameDDL = () => {
        if (WaterSupplyPumpingStationData && WaterSupplyPumpingStationData.table && WaterSupplyPumpingStationData.table.length > 0) {

            if (DashProjectTypeId == 6 && RoleID != '16') {
                let list = WaterSupplyPumpingStationData.table.map((item, index) => ({
                    value: item.m_Distri_WS_PumpStationID,
                    label: item.pumpStation,
                }))
                setWaterSupplyPumpingStation({
                    DDL: list,
                    // ID: rowData.m_wS_PumpStationID ,
                    // Label: rowData.pumpStation 
                    Id: 0,
                    Label: "Select...",
                })
            } 
            else if (DashProjectTypeId == 9) { // TTP
                let list = WaterSupplyPumpingStationData.table.map((item, index) => ({
                    value: item.m_ttP_PumpStationID,
                    label: item.pumpStation,
                }))
                setWaterSupplyPumpingStation({
                    DDL: list,
                    Id: 0,
                    Label: "Select...",
                })
            }else {
                let list = WaterSupplyPumpingStationData.table.map((item, index) => ({
                    value: item.m_wS_PumpStationID,
                    label: item.pumpStation,
                }))
                setWaterSupplyPumpingStation({
                    DDL: list,
                    // ID: rowData.m_wS_PumpStationID ,
                    // Label: rowData.pumpStation 
                    Id: 0,
                    Label: "Select...",
                })
            }

        }
        else {
            setWaterSupplyPumpingStation({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }


    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Pumping Station {Flag && <AstricSign />} </b></label>
            <Select
                // isClearable={isClearable === false ? false : true}
                // isRtl={isRtl}
                // className='ddl_width3'
                isDisabled={Flag === 'Update' && IsDisabled ? true : false}
                isSearchable
                maxMenuHeight={150}
                value={{ value: WaterSupplyPumpingStation.ID, label: WaterSupplyPumpingStation.Label }}
                onChange={(e) => {
                    e ?
                        setWaterSupplyPumpingStation({ ...WaterSupplyPumpingStation, ID: e.value, Label: e.label })
                        :
                        setWaterSupplyPumpingStation({ ...WaterSupplyPumpingStation, ID: 1, Label: "Select..." })

                }}
                options={WaterSupplyPumpingStation.DDL}
            />
        </div>
    )
}